import { apiGet } from '../../../shared/api/client';
import { endpoints } from '../../../shared/config/endpoints';
import type { CmsPage } from './apiTypes';

export async function fetchCmsPages(): Promise<CmsPage[]> {
  const response = await apiGet<unknown>(endpoints.cms);
  const envelope = response as { data?: { pages?: CmsPage[] }; pages?: CmsPage[] };
  return envelope?.data?.pages ?? envelope?.pages ?? [];
}
